import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import { ReactComponent as CloseSvg } from 'assets/ic-close-modal.svg';

const styles = (theme) => ({
  rootLarge: {
    maxWidth: '80%',
  },
  title: {
    margin: 0,
    padding: 12,
  },
  titleText: {
    fontSize: '20px',
  },
  titleLarge: {
    fontSize: '26px',
    fontWeight: 'bold',
    color: theme.palette.common.darkGray,
  },
  titleTextCenter: {
    fontSize: '20px',
    textAlign: 'center',
  },
  titleAllign: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    height: '40px',
  },
  titleTextAllign: {
    height: '40px',
    width: '100%',
    marginLeft: '5px',
  },
  closeButton: {
    position: 'absolute',
    right: 1,
    top: 3,
    color: theme.palette.common.white,
  },
  message: {
    fontSize: '14px',
    color: theme.palette.common.gray,
  },
  topIcon: {
    width: '80px',
    height: '80px',
    margin: 'auto',
  },
  leftIcon: {
    position: 'center',
    top: theme.spacing(1),
    width: '40px',
    height: '40px',
  },
  dialogActionsSpacing: {
    '& > *': {
      marginLeft: '5px',
      marginRight: '5px',
    },
  },
  paper: {
    padding: '40px',
    [theme.breakpoints.down('sm')]: {
      padding: '16px 24px',
    },
  },
  content: {
    [theme.breakpoints.down('xs')]: {
      overflowX: 'hidden',
      padding: '0px 5px 0px 0px',
      marginTop: '60px',
      '& a': {
        wordWrap: 'break-word',
      },
    },
    '&::-webkit-scrollbar': {
      // General scrollbar
      width: '6px',
      height: '10px',
    },
    '&::-webkit-scrollbar-button': {
      // Side buttons
      width: '0px',
      height: '0px',
    },
    '&::-webkit-scrollbar-thumb': {
      // Scrollbar slider
      background: '#004a8c',
      borderRadius: '5px',
    },
    '&::-webkit-scrollbar-thumb:hover': {
      // Slider hover
      background: '#004a8c',
    },
    '&::-webkit-scrollbar-thumb:active': {
      // Slider active
      background: '#004a8c',
    },
    '&::-webkit-scrollbar-track': {
      // Scrollbar track
      background: '#ccc',
      borderRadius: '5px',
    },
    '&::-webkit-scrollbar-track:hover': {
      // Track hover
      background: '#ccc',
    },
    '&::-webkit-scrollbar-track:active': {
      // Track active
      background: '#ccc',
    },
    '&::-webkit-scrollbar-corner': {
      // Scrollbar corners where scrollbars meet
      background: 'transparent',
    },
  },
});

class Modal extends React.PureComponent {
  onScroll = (e) => {
    const { scrolledToEnd } = this.props;
    if (
      e.target.offsetHeight + e.target.scrollTop >=
      e.target.scrollHeight - 10
    ) {
      if (scrolledToEnd) scrolledToEnd();
    }
  };

  render() {
    const {
      classes,
      controls,
      title,
      message,
      open,
      onClose,
      icon,
      type,
    } = this.props;

    let iconClass = type === 'topIcon' ? classes.topIcon : classes.leftIcon;
    let titleTextClass =
      type === 'large'
        ? classes.titleLarge
        : type === 'leftIcon'
        ? classes.titleTextCenter
        : classes.titleText;
    let maxWidth = type === 'large' ? 'md' : 'sm';
    return (
      <Dialog
        open={open}
        onClose={onClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        scroll="paper"
        classes={{ paper: classes.paper }}
        BackdropProps={{
          invisible: true,
          style: { backgroundColor: '#E5E5E5' },
        }}
        PaperProps={{ style: { boxShadow: 'none' } }}
        maxWidth={maxWidth}>
        <MuiDialogTitle id="alert-dialog-title">
          <span>
            {icon && type === 'topIcon' && (
              <div className={classes.topIcon}>
                <this.props.icon className={classes.topIcon} />
              </div>
            )}

            <div className={classes.titleAllign}>
              {icon && type === 'leftIcon' && (
                <div>
                  <this.props.icon className={iconClass} />
                </div>
              )}
              <div className={classes.titleTextAllign}>
                <Typography className={titleTextClass}>{title}</Typography>
              </div>
            </div>

            {onClose && (
              <IconButton
                aria-label="Close"
                className={classes.closeButton}
                onClick={onClose}>
                <CloseSvg />
              </IconButton>
            )}
          </span>
        </MuiDialogTitle>
        <DialogContent
          onScroll={this.onScroll}
          classes={{ root: classes.content }}>
          {message}
        </DialogContent>
        <DialogActions className={classes.dialogActionsSpacing}>
          {controls}
        </DialogActions>
      </Dialog>
    );
  }
}

Modal.propTypes = {
  classes: PropTypes.object.isRequired,
  controls: PropTypes.object,
  title: PropTypes.string.isRequired,
  largeTitle: PropTypes.bool,
  message: PropTypes.object.isRequired,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
  scrolledToEnd: PropTypes.func,
  icon: PropTypes.object,
  type: PropTypes.oneOf(['topIcon', 'leftIcon', 'large']),
};

export default withStyles(styles)(Modal);
